










import PartnerDetailEdit from '../components/PartnerDetailEdit.vue'
import {Vue, Component, Watch, Prop} from "vue-property-decorator";

@Component({
    components: { PartnerDetailEdit },})
export default class MyProfile extends Vue {
    id = undefined;
    created() {
        this.id = this.$store.state.loginUser.pk;
    }
}

